var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDinnersClub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "40px",
    viewBox: "0 0 60 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "diners-club-international"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,35 C60,37.75 57.75,40 55,40 L5,40 C2.25,40 0,37.75 0,35 L0,5 C0,2.25 2.25,0 5,0 L55,0 C57.75,0 60,2.25 60,5 L60,35 Z",
    id: "Path",
    fill: "#074C95"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(18.000000, 10.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.11,9.99 C18.148,5.491 14.508,1.635 9.815,1.58 C5.133,1.526 1.307,5.258 1.306,9.977 C1.305,14.704 5.094,18.344 9.626,18.388 C14.401,18.434 18.144,14.54 18.11,9.99 Z M9.927,19.156 C9.859,19.141 9.085,19.116 9.016,19.112 C8.296,19.074 7.595,18.936 6.909,18.719 C5.222,18.187 3.801,17.248 2.65,15.906 C1.461,14.52 0.747,12.922 0.535,11.104 C0.511,10.901 0.481,10.698 0.454,10.495 C0.454,10.2 0.454,9.906 0.454,9.611 C0.469,9.549 0.489,9.487 0.497,9.424 C0.547,9.022 0.574,8.617 0.646,8.219 C0.965,6.466 1.727,4.929 2.966,3.647 C4.51,2.05 6.409,1.167 8.612,0.924 C8.815,0.902 9.759,0.871 9.961,0.845 C11.717,0.845 14.62,0.883 14.688,0.89 C14.957,0.919 15.228,0.93 15.494,0.973 C17.393,1.276 19.093,2.024 20.523,3.316 C22.715,5.296 23.709,7.777 23.525,10.726 C23.461,11.754 23.203,12.739 22.735,13.651 C21.124,16.793 18.546,18.585 15.056,19.075 C14.867,19.103 11.683,19.156 9.927,19.156 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.645,14.88 C11.645,11.608 11.645,8.353 11.645,5.095 C13.093,5.559 14.884,7.238 14.997,9.739 C15.114,12.35 13.368,14.277 11.645,14.88 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78,14.883 C6.183,14.324 4.284,12.469 4.432,9.671 C4.555,7.35 6.198,5.624 7.78,5.09 L7.78,14.883 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinnersClub);
export default __webpack_public_path__ + "static/media/dinners_club.047311273cb81f6d5f64c2cc279870db.svg";
export { ForwardRef as ReactComponent };